const items = ["PIZZA", "KEBABS", "SNACK PACKS", "OPEN TILL 3AM", "MILDURA"];

export default function Marquee() {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="relative py-10 border-y border-zinc-800 overflow-hidden bg-coal-800" data-testid="marquee-strip">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-6xl sm:text-8xl text-gold-fill px-6">{t}</span>
            <span className="w-3 h-3 bg-ember rotate-45" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
